import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

// 获取公共枚举
export const getEnumsList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "enums/all", {
    data: _params,
    method: "get",
  });
};
// 获取公共枚举
export const getDictList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "enums/allDict", {
    data: _params,
    method: "get",
  });
};

// 上传地址
export const fileUpload = () => {
  return `${api.url}common/minio/upload`;
};

// 上传图片
export const fileFnUpload = (params) => {
         return sendRequest(api.url + "common/minio/upload", {
           data: params,
           method: "POST",
         });
       };

// 直播间 - 获取直播间的拉流地址
export const roomGetPullStreamUrl = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "zxLiveRoom/getPullStreamUrl", {
    data: _params,
    method: "GET",
  });
};

// 轮播图 - 获取
export const bannerList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "banner/list", {
    data: _params,
    method: "GET",
  });
};
// 系统通知 - 获取最新的一条通知信息
export const sysNoticelast = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + "sysNotice/last", {
           data: _params,
           method: "GET",
         });
       };
//  发送绑定手机号码短信验证码-更新手机号
export const bindPhoneCode = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + "common/bindPhoneCode", {
           data: _params,
           method: "GET",
         });
       };
//  发送登录验证码--根据手机号码发送
export const loginVerifyCode = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + "common/loginVerifyCode", {
           data: _params,
           method: "GET",
         });
       };

//  发送登录验证码--发送忘记密码短信验证码
export const forgetPasswordCode = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + "common/forgetPasswordCode", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/common.js